import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { FlowType, IProofReading } from 'src/app/models/proofreading.model';
import { AlertService } from 'src/app/services/alert.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { ProjectService } from 'src/app/services/project.service';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { AuthService } from 'src/app/services/auth.service';
import { IMasterGroup } from 'src/app/project-dashboard/project-dashboard/project-dashboard.component';
import { TranslateService } from '@ngx-translate/core';
import { MasterProjectService } from 'src/app/services/project-master.service';

@Component({
    selector: 'app-project-master-card',
    templateUrl: './project-master-card.component.html',
    styleUrls: ['./project-master-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProjectsMasterCardsComponent extends ViewComponent {

    @Input() masterGroup: IMasterGroup;

    get master() {
        return this.masterGroup.master;
    }

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected s_proofreadings: ProofreadingService,
        protected s_projects: ProjectService,
        
        protected s_project_master: MasterProjectService
    ) {
        super(route, router, s_alert, s_loader, s_auth);
    }

    getPrefixRelecture(flow: FlowType) {
        return ProofreadingService.getPrefixRelecture(flow);
    }

    async newChildProject(identifier: string) {
        if (identifier) {
            const masterJob = (await this.s_project_master.find({ "identifier": identifier, type: 'Job_Maitre' }))[0];
            this.s_project_master.emitCurrent(masterJob);
            this.router.navigate(["/project/create/child"], { queryParams: { noReset: '1' } });
        }
    }

    async editMaster(identifier: string) {
        if (identifier) {
            const masterJob = (await this.s_project_master.find({ "identifier": identifier, type: 'Job_Maitre' }))[0];
            this.s_project_master.emitCurrent(masterJob);
            this.router.navigate(["/project/edit/master/" + masterJob._id]);
        }
    }
}